import * as React from 'react';
/**
 *
 * Original name: online only
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=20530%3A2413
 *
 */
export const OnlineOnlySync = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 4c-5.159 0-8 2.841-8 8s2.841 8 8 8 8-2.841 8-8-2.841-8-8-8Z", fill: "#8E8B87", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M12.25 8c-1.84 0-2.954.89-3.199 2.525C7.724 10.679 7 11.545 7 13c0 1.612.888 2.5 2.5 2.5H15c1.29 0 2-.71 2-2 0-1.115-.53-1.797-1.508-1.961.005-.094.008-.19.008-.289C15.5 9.154 14.346 8 12.25 8Z", fill: "#fff", vectorEffect: "non-scaling-stroke" })));
